// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./icon/header_user.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%; /* standardized alternative but still limited support */
    height: 60px;
    background-color: #303030;
    padding: 10px 0px;
    display: flex;
    align-items: center;
    z-index: 1000;
    border-bottom: 2px solid #444; /* subtle line */
}


.hamburger {
    display: none; /* Initially hidden on larger screens */
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    z-index: 999;
}

.hamburger .bar {
    display: block;
    width: 25px;
    height: 3px;
    margin: 5px auto;
    background-color: white;
    transition: all 0.3s ease;
}

.navbar {
    display: flex; /* Use flexbox */
    flex-direction: column; /* Ensure items stack vertically */
}



.navbar ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
}

.navbar li {
    margin: 0 15px;
    padding: 0;
    font-size: 15px;
    align-content: center;
    font-weight: 600;
}

.navbar a {
    color: white; /* Link color */
    text-decoration: none; /* Remove underline from links */
    font-size: 15px; /* Set font size */
    transition: color 0.3s ease; /* Smooth transition for hover effect */
    display: flex; /* Use flexbox for the link */
    align-items: center; /* Center text vertically */
    justify-content: Left-sided; /* Center text horizontally */
    height: 100%; /* Make the link take the full height of the navbar */
}

.navbar a:hover {
    color: #007bff;
}

.navbar .nav-link {
    color: white; padding: 10px 15px;
    display: block;
}

.navbar-mobile {
    display: flex; /* Use flexbox */
    flex-direction: column; /* Ensure items stack vertically */
}

.navbar-mobile ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
}

.navbar-mobile li {
    margin: 0 10px;
    padding: 0;
}
.navbar-mobile a {
    color: white; /* Link color */
    text-decoration: none; /* Remove underline from links */
    font-size: 20px; /* Set font size */
    transition: color 0.3s ease; /* Smooth transition for hover effect */
    display: flex; /* Use flexbox for the link */
    align-items: center; /* Center text vertically */
    justify-content: Left-sided; /* Center text horizontally */
    height: 100%; /* Make the link take the full height of the navbar */
}

.navbar-mobile a:hover {
    color: #007bff;
}

.navbar-moobile .nav-link {
    color: white; padding: 10px 15px;
    display: block;
}

.mobile-user-info {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Ensure the path is correct */
    background-size: cover; /* Cover the entire div */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Prevent the image from repeating */
    background-color: clear; /* Ensure it has a background */
    z-index: 10; /* Ensure it appears above other elements */
    padding-top:10px ;
    padding-bottom:10px ;
    padding-left:20px ;
    padding-right:20px ;
    align-content: Center;
}
.signup-header-button {
    background-color: #007bff;
    color: white;
    text-decoration: none; /* Remove underline from links */
    border: none;
    font-size: 15px; /* Set font size */
    padding: 10px; /* Adjust padding as needed */
    cursor: pointer;
    border-radius: 5px;
    font-weight: 600;
    transition: background-color 0.3s ease;
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
    height: 100%; /* Make the link take the full height of the navbar */
    align-items: center; /* Center text vertically */
    width: 100%;
}

.signup-button:hover {
    background-color: #0056b3;
}

.logout-button{
    display: flex;
    color: red; /* Link color */
    text-decoration: none; /* Remove underline from links */
    font-size: 16px; /* Set font size */
    font-weight: 600; /* Set font weight */
    transition: color 0.3s ease; /* Smooth transition for hover effect */
    align-items: center; /* Center text vertically */
    
}

/* Mobile Menu Animation */
.hamburger.active .bar:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
    opacity: 0;
}

.hamburger.active .bar:nth-child(2) {
    opacity: 0;
}

.hamburger.active .bar:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
    opacity: 0;
}

.mobile-menu {
    display: block;
}

/* Left-sided Mobile Menu */
@media (max-width: 768px) {
    .hamburger {
        display: block; /* Show hamburger on mobile */
        padding-left: 20px;
    }
    
    .mobile-menu {
    display: block;
    z-index: 100;
    left: 200px;
    padding: 10px;
}

    .header {
        justify-content: flex-start; /* Align items to the left */
    }

    .logo {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
    }

    .logo img {
        max-height: 60px !important; 
        width: auto; 
        margin: 0 auto; 
    }
    
    .logo-container {
     display: flex;
     align-items: center;
     gap: 12px; /* space between logo and icon */
    }
    
    .addtocart-mobile {
        height: 35px;
        fill: white;
        width: 35px;
    }

    .navbar-mobile {
        position: fixed;
        top: 0;
        left: -100%;
        height: 100%;
        width: 75%;
        background-color: #303030;
        box-shadow: 2px 0 5px rgba(0,0,0,0.4);
        transition: left 0.3s ease;
        z-index: 999;
    }

    .navbar-mobile.active {
        left: 0;
    }

    .navbar-mobile ul {
        flex-direction: column;
        
    }

    .navbar-mobile li {
        margin: 10% 0%;
        text-align: left;
    }
    
    .navbar-mobile a {
        font-size: 1.1rem;
        font-weight: 450;
        
    }

    .signup-header-button {
        width: 50%;
        text-align: center;
    }
    
    .mobile-user-info {
        display: block; /* Ensure user info is displayed */
    }
    
    .logout-button {
        font-size: 1.1rem;
    }

    /* Hide dropdown on mobile */
    .dropdown,
    .dashboard-dropdown,.dashboard-toggle,.dashboard-dropdown.active,.navbar {
        display: none; /* Prevent dropdown from showing on mobile */
    }
    
    .menu-icon {
      width: 15px;
    }
    
    .mobile-cart-wrapper {
        display: flex;
        align-items: center;
        margin-left: auto; /* pushes it to the right */
        margin-right: 30px; /* optional spacing from right edge */
    }

    
    .cart-badge-mobile {
        position: absolute;
        top: -30px;
        left: 25px;
        background-color: red;
        color: white;
        font-size: 0.8rem;
        border-radius: 50%;
        border: 4px solid #303030;
        display: flex;
        width: 21px;
        height: 21px;
        justify-content: center;
        /* justify-items: center; */
        align-items: center;
    }
    
    .cart-icon-container-mobile {
        position: relative;
    }
    
    .user-email {
        font-size: 1.2rem;
        color: rgba(255, 255, 255, 0.7);
    }
}

/* Desktop Layout */
@media (min-width: 769px) {
    .header {
        justify-content: space-between; /* Space between logo and navbar */
    }

    .navbar {
        display: flex; /* Keep navbar visible on desktop */
        margin-left: auto; /* Push navbar to the right */
    }
    
    .navbar a {
        font-weight: 600; /* Set font weight */
    }

    .logo {
        margin: 20px; /* Reset margin for desktop */
    }
    
    .logo img {
        max-height: 60px !important; 
        width: auto; 
        margin: 0 auto; 
    }
    
    .dropdown {
        display: block; /* Show dropdown on desktop */
    }
    
    .mobile-user-info, .logout-button, .hamburger, .hamburger.active, .mobile-menu-content, .menu-title, .navbar-mobile, .addtocart-mobile, .cart-badge-mobile {
        display: none;
    }
    
    .mobile-menu {
        display: none;
    }
    
    .logout-button {
        height: 100%; /* Make the link take the full height of the navbar */
    }
    
    .user-email {
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.7);
    }

}

.header-divider {
    height: 1px;
    background-color: white;
    margin: 0;
    width: 100%;
}

/* Dropdown Menu Styles */
.dropdown {
    position: relative;
    display: inline-block; /* Allow dropdown to be inline with other elements */
}

.dashboard-toggle {
    color: #007bff; /* Change this to your desired text color */
    font-weight: 500; /* Change this to your desired font weight */
    cursor: pointer; /* Change cursor to pointer on hover */
    transition: color 0.3s ease; /* Smooth transition for color change */
}

.dashboard-toggle:hover {
    color: #0056b3; /* Change color on hover (optional) */
}

.arrow {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 13px;
}

.arrow.open {
  transform: rotate(90deg); /* Rotate arrow up */
}

.dashboard-dropdown {
    margin-right: 15px;
    z-index: 100;
    position: absolute;
    right: 0;
    top: calc(100% + 10px);
    background: #424242;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    min-width: 220px; /* You can adjust this width as needed */
    overflow: visible;
    opacity: 0; /* Initially hidden */
    transform: translateY(-10px); /* Initial position */
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    visibility: hidden; /* Initially hidden */
    display: flex; /* Use flexbox for layout */
    flex-direction: column; /* Arrange items in a column */
}

.dashboard-dropdown.active {
    opacity: 1; /* Make visible */
    transform: translateY(0); /* Move to original position */
    visibility: visible; /* Make visible */
    top: 100px;
}

.dashboard-dropdown ul {
    display: flex; /* Use flexbox for horizontal layout */
    flex-direction: column; /* Arrange items in a column */
    padding: 8px 0;
    margin: 0;
}

.dashboard-dropdown li {
    padding: 12px 25px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500; /* Change this to your desired font weight */
    display: flex;
    align-items: center;
    gap: 12px;
    transition: all 0.2s ease;
    transition: color 0.3s ease; /* Smooth transition for hover effect */
    cursor: pointer;
}

.dashboard-dropdown li:hover {
    background: rgba(255, 255, 255, 0.05);
    padding-left: 30px; /* Optional: Add padding on hover */
    color: #007bff;
}

/* Additional Styles for User Info */
.dashboard-user-info {
    display: flex;
    align-items: center;
    padding: 10px;
}

.user-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #007bff; /* Placeholder color */
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    margin-bottom: 20px;
    margin-left: 10px;
}

.user-avatar-v2 {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #007bff; /* Placeholder color */
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
}

.user-meta {
    margin-left: 10px;
}

.username {
    font-size: 18px;
    font-weight: 400;
    color: white;
    text-transform: capitalize;
}


.mobile-menu-content {
    padding: 5px 15px;
    border-bottom: 1px solid #555;
}

.menu-title {
    font-size: 1.2rem;
    font-weight: 500;
    color: #ccc;
    margin: 5% 0%;
}

.menu-icon {
  width: 1.2rem;
  height: 100%;
  margin-right: 40px;
  fill: white;
  cursor: pointer;
}

.menu-icon-v2 {
  width: 20px;
  height: 100%;
  margin-right: 40px;
  fill: white;
  cursor: pointer;
}

.cart-header-item {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
}

.cart-icon-container {
    position: relative;
}

.cart-badge {
    position: absolute;
    top: -12px;
    left: 14px;
    background-color: red;
    color: white;
    font-size: 10px;
    border-radius: 50%;
    width: 16px;
    text-align: center;
    border: 4px solid #303030;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Add these styles to your existing Header.css file */

.user-type-badge-desktop {
  margin-top: 5px;
  text-align: center;
}

.user-type-badge-mobile {
  margin-top: 10px;
  margin-left: 10px;
}

.user-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: bold;
  color: white;
  text-transform: capitalize;
  letter-spacing: 0.5px;
}

.user-badge.admin {
  background-color: #e53e3e; /* Red color for Admin */
}

.user-badge.reseller {
  background-color: #3182ce; /* Blue color for Reseller */
}

.user-badge.customer {
  background-color: #48bb78; /* Green color for Customer */
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW,EAAE,uDAAuD;IACpE,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,6BAA6B,EAAE,gBAAgB;AACnD;;;AAGA;IACI,aAAa,EAAE,uCAAuC;IACtD,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa,EAAE,gBAAgB;IAC/B,sBAAsB,EAAE,kCAAkC;AAC9D;;;;AAIA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY,EAAE,eAAe;IAC7B,qBAAqB,EAAE,gCAAgC;IACvD,eAAe,EAAE,kBAAkB;IACnC,2BAA2B,EAAE,uCAAuC;IACpE,aAAa,EAAE,6BAA6B;IAC5C,mBAAmB,EAAE,2BAA2B;IAChD,2BAA2B,EAAE,6BAA6B;IAC1D,YAAY,EAAE,qDAAqD;AACvE;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY,EAAE,kBAAkB;IAChC,cAAc;AAClB;;AAEA;IACI,aAAa,EAAE,gBAAgB;IAC/B,sBAAsB,EAAE,kCAAkC;AAC9D;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,YAAY,EAAE,eAAe;IAC7B,qBAAqB,EAAE,gCAAgC;IACvD,eAAe,EAAE,kBAAkB;IACnC,2BAA2B,EAAE,uCAAuC;IACpE,aAAa,EAAE,6BAA6B;IAC5C,mBAAmB,EAAE,2BAA2B;IAChD,2BAA2B,EAAE,6BAA6B;IAC1D,YAAY,EAAE,qDAAqD;AACvE;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY,EAAE,kBAAkB;IAChC,cAAc;AAClB;;AAEA;IACI,yDAAgD,EAAE,+BAA+B;IACjF,sBAAsB,EAAE,yBAAyB;IACjD,2BAA2B,EAAE,qBAAqB;IAClD,4BAA4B,EAAE,qCAAqC;IACnE,uBAAuB,EAAE,+BAA+B;IACxD,WAAW,EAAE,2CAA2C;IACxD,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB,EAAE,gCAAgC;IACvD,YAAY;IACZ,eAAe,EAAE,kBAAkB;IACnC,aAAa,EAAE,6BAA6B;IAC5C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;IACtC,sBAAsB,EAAE,uEAAuE;IAC/F,YAAY,EAAE,qDAAqD;IACnE,mBAAmB,EAAE,2BAA2B;IAChD,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,UAAU,EAAE,eAAe;IAC3B,qBAAqB,EAAE,gCAAgC;IACvD,eAAe,EAAE,kBAAkB;IACnC,gBAAgB,EAAE,oBAAoB;IACtC,2BAA2B,EAAE,uCAAuC;IACpE,mBAAmB,EAAE,2BAA2B;;AAEpD;;AAEA,0BAA0B;AAC1B;IACI,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI;QACI,cAAc,EAAE,6BAA6B;QAC7C,kBAAkB;IACtB;;IAEA;IACA,cAAc;IACd,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;IAEI;QACI,2BAA2B,EAAE,4BAA4B;IAC7D;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,2BAA2B;QAC3B,YAAY;IAChB;;IAEA;QACI,2BAA2B;QAC3B,WAAW;QACX,cAAc;IAClB;;IAEA;KACC,aAAa;KACb,mBAAmB;KACnB,SAAS,EAAE,gCAAgC;IAC5C;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,WAAW;IACf;;IAEA;QACI,eAAe;QACf,MAAM;QACN,WAAW;QACX,YAAY;QACZ,UAAU;QACV,yBAAyB;QACzB,qCAAqC;QACrC,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,sBAAsB;;IAE1B;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;;IAEpB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,cAAc,EAAE,kCAAkC;IACtD;;IAEA;QACI,iBAAiB;IACrB;;IAEA,4BAA4B;IAC5B;;QAEI,aAAa,EAAE,4CAA4C;IAC/D;;IAEA;MACE,WAAW;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB,EAAE,2BAA2B;QAC9C,kBAAkB,EAAE,qCAAqC;IAC7D;;;IAGA;QACI,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,qBAAqB;QACrB,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,2BAA2B;QAC3B,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,+BAA+B;IACnC;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,8BAA8B,EAAE,kCAAkC;IACtE;;IAEA;QACI,aAAa,EAAE,mCAAmC;QAClD,iBAAiB,EAAE,6BAA6B;IACpD;;IAEA;QACI,gBAAgB,EAAE,oBAAoB;IAC1C;;IAEA;QACI,YAAY,EAAE,6BAA6B;IAC/C;;IAEA;QACI,2BAA2B;QAC3B,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,cAAc,EAAE,6BAA6B;IACjD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY,EAAE,qDAAqD;IACvE;;IAEA;QACI,kBAAkB;QAClB,+BAA+B;IACnC;;AAEJ;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,qBAAqB,EAAE,oDAAoD;AAC/E;;AAEA;IACI,cAAc,EAAE,2CAA2C;IAC3D,gBAAgB,EAAE,4CAA4C;IAC9D,eAAe,EAAE,sCAAsC;IACvD,2BAA2B,EAAE,uCAAuC;AACxE;;AAEA;IACI,cAAc,EAAE,qCAAqC;AACzD;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,wBAAwB,EAAE,oBAAoB;AAChD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB,EAAE,wCAAwC;IAC1D,iBAAiB;IACjB,UAAU,EAAE,qBAAqB;IACjC,4BAA4B,EAAE,qBAAqB;IACnD,iDAAiD;IACjD,kBAAkB,EAAE,qBAAqB;IACzC,aAAa,EAAE,2BAA2B;IAC1C,sBAAsB,EAAE,8BAA8B;AAC1D;;AAEA;IACI,UAAU,EAAE,iBAAiB;IAC7B,wBAAwB,EAAE,8BAA8B;IACxD,mBAAmB,EAAE,iBAAiB;IACtC,UAAU;AACd;;AAEA;IACI,aAAa,EAAE,sCAAsC;IACrD,sBAAsB,EAAE,8BAA8B;IACtD,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB,EAAE,4CAA4C;IAC9D,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,2BAA2B,EAAE,uCAAuC;IACpE,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB,EAAE,mCAAmC;IACvD,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,sBAAsB;IACjD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,sBAAsB;IACjD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;AAC9B;;;AAGA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,sDAAsD;;AAEtD;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;AAC1D","sourcesContent":["/* Base Styles */\n.header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%; /* standardized alternative but still limited support */\n    height: 60px;\n    background-color: #303030;\n    padding: 10px 0px;\n    display: flex;\n    align-items: center;\n    z-index: 1000;\n    border-bottom: 2px solid #444; /* subtle line */\n}\n\n\n.hamburger {\n    display: none; /* Initially hidden on larger screens */\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 10px;\n    z-index: 999;\n}\n\n.hamburger .bar {\n    display: block;\n    width: 25px;\n    height: 3px;\n    margin: 5px auto;\n    background-color: white;\n    transition: all 0.3s ease;\n}\n\n.navbar {\n    display: flex; /* Use flexbox */\n    flex-direction: column; /* Ensure items stack vertically */\n}\n\n\n\n.navbar ul {\n    list-style: none;\n    display: flex;\n    margin: 0;\n    padding: 0;\n}\n\n.navbar li {\n    margin: 0 15px;\n    padding: 0;\n    font-size: 15px;\n    align-content: center;\n    font-weight: 600;\n}\n\n.navbar a {\n    color: white; /* Link color */\n    text-decoration: none; /* Remove underline from links */\n    font-size: 15px; /* Set font size */\n    transition: color 0.3s ease; /* Smooth transition for hover effect */\n    display: flex; /* Use flexbox for the link */\n    align-items: center; /* Center text vertically */\n    justify-content: Left-sided; /* Center text horizontally */\n    height: 100%; /* Make the link take the full height of the navbar */\n}\n\n.navbar a:hover {\n    color: #007bff;\n}\n\n.navbar .nav-link {\n    color: white; padding: 10px 15px;\n    display: block;\n}\n\n.navbar-mobile {\n    display: flex; /* Use flexbox */\n    flex-direction: column; /* Ensure items stack vertically */\n}\n\n.navbar-mobile ul {\n    list-style: none;\n    display: flex;\n    margin: 0;\n    padding: 0;\n}\n\n.navbar-mobile li {\n    margin: 0 10px;\n    padding: 0;\n}\n.navbar-mobile a {\n    color: white; /* Link color */\n    text-decoration: none; /* Remove underline from links */\n    font-size: 20px; /* Set font size */\n    transition: color 0.3s ease; /* Smooth transition for hover effect */\n    display: flex; /* Use flexbox for the link */\n    align-items: center; /* Center text vertically */\n    justify-content: Left-sided; /* Center text horizontally */\n    height: 100%; /* Make the link take the full height of the navbar */\n}\n\n.navbar-mobile a:hover {\n    color: #007bff;\n}\n\n.navbar-moobile .nav-link {\n    color: white; padding: 10px 15px;\n    display: block;\n}\n\n.mobile-user-info {\n    background-image: url('./icon/header_user.jpeg'); /* Ensure the path is correct */\n    background-size: cover; /* Cover the entire div */\n    background-position: center; /* Center the image */\n    background-repeat: no-repeat; /* Prevent the image from repeating */\n    background-color: clear; /* Ensure it has a background */\n    z-index: 10; /* Ensure it appears above other elements */\n    padding-top:10px ;\n    padding-bottom:10px ;\n    padding-left:20px ;\n    padding-right:20px ;\n    align-content: Center;\n}\n.signup-header-button {\n    background-color: #007bff;\n    color: white;\n    text-decoration: none; /* Remove underline from links */\n    border: none;\n    font-size: 15px; /* Set font size */\n    padding: 10px; /* Adjust padding as needed */\n    cursor: pointer;\n    border-radius: 5px;\n    font-weight: 600;\n    transition: background-color 0.3s ease;\n    box-sizing: border-box; /* Include padding and border in the element's total width and height */\n    height: 100%; /* Make the link take the full height of the navbar */\n    align-items: center; /* Center text vertically */\n    width: 100%;\n}\n\n.signup-button:hover {\n    background-color: #0056b3;\n}\n\n.logout-button{\n    display: flex;\n    color: red; /* Link color */\n    text-decoration: none; /* Remove underline from links */\n    font-size: 16px; /* Set font size */\n    font-weight: 600; /* Set font weight */\n    transition: color 0.3s ease; /* Smooth transition for hover effect */\n    align-items: center; /* Center text vertically */\n    \n}\n\n/* Mobile Menu Animation */\n.hamburger.active .bar:nth-child(1) {\n    transform: translateY(8px) rotate(45deg);\n    opacity: 0;\n}\n\n.hamburger.active .bar:nth-child(2) {\n    opacity: 0;\n}\n\n.hamburger.active .bar:nth-child(3) {\n    transform: translateY(-8px) rotate(-45deg);\n    opacity: 0;\n}\n\n.mobile-menu {\n    display: block;\n}\n\n/* Left-sided Mobile Menu */\n@media (max-width: 768px) {\n    .hamburger {\n        display: block; /* Show hamburger on mobile */\n        padding-left: 20px;\n    }\n    \n    .mobile-menu {\n    display: block;\n    z-index: 100;\n    left: 200px;\n    padding: 10px;\n}\n\n    .header {\n        justify-content: flex-start; /* Align items to the left */\n    }\n\n    .logo {\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        z-index: 999;\n    }\n\n    .logo img {\n        max-height: 60px !important; \n        width: auto; \n        margin: 0 auto; \n    }\n    \n    .logo-container {\n     display: flex;\n     align-items: center;\n     gap: 12px; /* space between logo and icon */\n    }\n    \n    .addtocart-mobile {\n        height: 35px;\n        fill: white;\n        width: 35px;\n    }\n\n    .navbar-mobile {\n        position: fixed;\n        top: 0;\n        left: -100%;\n        height: 100%;\n        width: 75%;\n        background-color: #303030;\n        box-shadow: 2px 0 5px rgba(0,0,0,0.4);\n        transition: left 0.3s ease;\n        z-index: 999;\n    }\n\n    .navbar-mobile.active {\n        left: 0;\n    }\n\n    .navbar-mobile ul {\n        flex-direction: column;\n        \n    }\n\n    .navbar-mobile li {\n        margin: 10% 0%;\n        text-align: left;\n    }\n    \n    .navbar-mobile a {\n        font-size: 1.1rem;\n        font-weight: 450;\n        \n    }\n\n    .signup-header-button {\n        width: 50%;\n        text-align: center;\n    }\n    \n    .mobile-user-info {\n        display: block; /* Ensure user info is displayed */\n    }\n    \n    .logout-button {\n        font-size: 1.1rem;\n    }\n\n    /* Hide dropdown on mobile */\n    .dropdown,\n    .dashboard-dropdown,.dashboard-toggle,.dashboard-dropdown.active,.navbar {\n        display: none; /* Prevent dropdown from showing on mobile */\n    }\n    \n    .menu-icon {\n      width: 15px;\n    }\n    \n    .mobile-cart-wrapper {\n        display: flex;\n        align-items: center;\n        margin-left: auto; /* pushes it to the right */\n        margin-right: 30px; /* optional spacing from right edge */\n    }\n\n    \n    .cart-badge-mobile {\n        position: absolute;\n        top: -30px;\n        left: 25px;\n        background-color: red;\n        color: white;\n        font-size: 0.8rem;\n        border-radius: 50%;\n        border: 4px solid #303030;\n        display: flex;\n        width: 21px;\n        height: 21px;\n        justify-content: center;\n        /* justify-items: center; */\n        align-items: center;\n    }\n    \n    .cart-icon-container-mobile {\n        position: relative;\n    }\n    \n    .user-email {\n        font-size: 1.2rem;\n        color: rgba(255, 255, 255, 0.7);\n    }\n}\n\n/* Desktop Layout */\n@media (min-width: 769px) {\n    .header {\n        justify-content: space-between; /* Space between logo and navbar */\n    }\n\n    .navbar {\n        display: flex; /* Keep navbar visible on desktop */\n        margin-left: auto; /* Push navbar to the right */\n    }\n    \n    .navbar a {\n        font-weight: 600; /* Set font weight */\n    }\n\n    .logo {\n        margin: 20px; /* Reset margin for desktop */\n    }\n    \n    .logo img {\n        max-height: 60px !important; \n        width: auto; \n        margin: 0 auto; \n    }\n    \n    .dropdown {\n        display: block; /* Show dropdown on desktop */\n    }\n    \n    .mobile-user-info, .logout-button, .hamburger, .hamburger.active, .mobile-menu-content, .menu-title, .navbar-mobile, .addtocart-mobile, .cart-badge-mobile {\n        display: none;\n    }\n    \n    .mobile-menu {\n        display: none;\n    }\n    \n    .logout-button {\n        height: 100%; /* Make the link take the full height of the navbar */\n    }\n    \n    .user-email {\n        font-size: 0.85rem;\n        color: rgba(255, 255, 255, 0.7);\n    }\n\n}\n\n.header-divider {\n    height: 1px;\n    background-color: white;\n    margin: 0;\n    width: 100%;\n}\n\n/* Dropdown Menu Styles */\n.dropdown {\n    position: relative;\n    display: inline-block; /* Allow dropdown to be inline with other elements */\n}\n\n.dashboard-toggle {\n    color: #007bff; /* Change this to your desired text color */\n    font-weight: 500; /* Change this to your desired font weight */\n    cursor: pointer; /* Change cursor to pointer on hover */\n    transition: color 0.3s ease; /* Smooth transition for color change */\n}\n\n.dashboard-toggle:hover {\n    color: #0056b3; /* Change color on hover (optional) */\n}\n\n.arrow {\n  display: inline-block;\n  transition: transform 0.3s ease;\n  font-size: 13px;\n}\n\n.arrow.open {\n  transform: rotate(90deg); /* Rotate arrow up */\n}\n\n.dashboard-dropdown {\n    margin-right: 15px;\n    z-index: 100;\n    position: absolute;\n    right: 0;\n    top: calc(100% + 10px);\n    background: #424242;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    min-width: 220px; /* You can adjust this width as needed */\n    overflow: visible;\n    opacity: 0; /* Initially hidden */\n    transform: translateY(-10px); /* Initial position */\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    visibility: hidden; /* Initially hidden */\n    display: flex; /* Use flexbox for layout */\n    flex-direction: column; /* Arrange items in a column */\n}\n\n.dashboard-dropdown.active {\n    opacity: 1; /* Make visible */\n    transform: translateY(0); /* Move to original position */\n    visibility: visible; /* Make visible */\n    top: 100px;\n}\n\n.dashboard-dropdown ul {\n    display: flex; /* Use flexbox for horizontal layout */\n    flex-direction: column; /* Arrange items in a column */\n    padding: 8px 0;\n    margin: 0;\n}\n\n.dashboard-dropdown li {\n    padding: 12px 25px;\n    color: rgba(255, 255, 255, 0.9);\n    font-weight: 500; /* Change this to your desired font weight */\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    transition: all 0.2s ease;\n    transition: color 0.3s ease; /* Smooth transition for hover effect */\n    cursor: pointer;\n}\n\n.dashboard-dropdown li:hover {\n    background: rgba(255, 255, 255, 0.05);\n    padding-left: 30px; /* Optional: Add padding on hover */\n    color: #007bff;\n}\n\n/* Additional Styles for User Info */\n.dashboard-user-info {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n}\n\n.user-avatar {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: #007bff; /* Placeholder color */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-weight: bold;\n    margin-bottom: 20px;\n    margin-left: 10px;\n}\n\n.user-avatar-v2 {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #007bff; /* Placeholder color */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-weight: bold;\n}\n\n.user-meta {\n    margin-left: 10px;\n}\n\n.username {\n    font-size: 18px;\n    font-weight: 400;\n    color: white;\n    text-transform: capitalize;\n}\n\n\n.mobile-menu-content {\n    padding: 5px 15px;\n    border-bottom: 1px solid #555;\n}\n\n.menu-title {\n    font-size: 1.2rem;\n    font-weight: 500;\n    color: #ccc;\n    margin: 5% 0%;\n}\n\n.menu-icon {\n  width: 1.2rem;\n  height: 100%;\n  margin-right: 40px;\n  fill: white;\n  cursor: pointer;\n}\n\n.menu-icon-v2 {\n  width: 20px;\n  height: 100%;\n  margin-right: 40px;\n  fill: white;\n  cursor: pointer;\n}\n\n.cart-header-item {\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.cart-icon-container {\n    position: relative;\n}\n\n.cart-badge {\n    position: absolute;\n    top: -12px;\n    left: 14px;\n    background-color: red;\n    color: white;\n    font-size: 10px;\n    border-radius: 50%;\n    width: 16px;\n    text-align: center;\n    border: 4px solid #303030;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Add these styles to your existing Header.css file */\n\n.user-type-badge-desktop {\n  margin-top: 5px;\n  text-align: center;\n}\n\n.user-type-badge-mobile {\n  margin-top: 10px;\n  margin-left: 10px;\n}\n\n.user-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: bold;\n  color: white;\n  text-transform: capitalize;\n  letter-spacing: 0.5px;\n}\n\n.user-badge.admin {\n  background-color: #e53e3e; /* Red color for Admin */\n}\n\n.user-badge.reseller {\n  background-color: #3182ce; /* Blue color for Reseller */\n}\n\n.user-badge.customer {\n  background-color: #48bb78; /* Green color for Customer */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
